document.addEventListener('DOMContentLoaded', () => {
  const secondFactorForm = document.querySelector('.second-factor-form')
  if (secondFactorForm) {
    if (
      secondFactorForm.classList.contains('second-factor-form--email') ||
      secondFactorForm.classList.contains('second-factor-form--sms')
    ) {
      secondFactorForm
        .querySelector('.second-factor-btn-change-to')
        ?.addEventListener('click', (event) => {
          event.preventDefault()
          const input = document.createElement('input')
          input.setAttribute('type', 'hidden')
          input.setAttribute('name', 'change_to')
          const form = secondFactorForm.querySelector('form')
          form.appendChild(input)
          form.submit()
        })
    }
  }

  const otpInput = document.querySelector('input.one-time-code')
  if (otpInput) {
    const submitButton = otpInput
      .closest('form')
      .querySelector('button[type=submit]')
    submitButton.setAttribute('disabled', 'true')
    const checkInputLength = () => {
      if (otpInput.value.length === 6) {
        submitButton.removeAttribute('disabled')
      } else {
        submitButton.setAttribute('disabled', 'true')
      }
    }
    otpInput.addEventListener('input', checkInputLength)
    checkInputLength()
  }
})
